export default __webpack_public_path__ + "static/media/RoundWidgetBackgroudn.43a3f818.png";